import React, { useEffect, useState } from "react";

import Label from "@busbud/design-system-components/dist/Label/Label";
import Stack from "@busbud/design-system-components/dist/Stack/Stack";
import { Button, IconLongArrow } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";
import { clickedDownloadTickets } from "@app/tracking/account-tracking";
import type { NapiV2Ticket } from "@app/types/napi-v2-tickets-types";

import { DownloadGooglePayTicket } from "./components/download-google-pay-tickets";
import { PassengerTicketLabel } from "./components/passenger-ticket";
import { AppleWalletTicket } from "../../app-wallet-ticket";

export const DownloadTicketsType: React.FC<{
  ticket_type: string;
  tickets: NapiV2Ticket[];
}> = ({ ticket_type, tickets }) => {
  const { translator, tracker } = useAppContext();
  const [has_error, setError] = useState(false);
  useEffect(() => {
    setError(false);
  }, [ticket_type]);

  const getDownloadTicketComponent = (
    ticket_type: string,
    ticket: NapiV2Ticket
  ) => {
    switch (ticket_type) {
      case "pdf":
        return (
          <Button
            size="md"
            variant="contained"
            iconEnd={<IconLongArrow variant="down" size="md" />}
            appearance="default"
            url={ticket.urls?.pdf!}
            target="_blank"
            onClick={() => tracker.track(clickedDownloadTickets(ticket_type))}
          >
            {translator.t("!purchase-confirmation.ticket-button.download")}
          </Button>
        );
      case "apple_wallet":
        return <AppleWalletTicket pkpass_url={ticket.urls?.pkpass!} />;
      case "google_pay_ticket":
        return (
          <DownloadGooglePayTicket
            ticket={ticket}
            onError={() => setError(true)}
          />
        );
    }
  };

  return (
    <Stack direction="column" spacing={3}>
      {!!has_error && (
        <Label size="lg">
          {translator.t(
            "!checkout.thank-you.tickets.google-pay-passes-not-available"
          )}
        </Label>
      )}
      {!has_error &&
        tickets.map(ticket => (
          <Stack
            key={ticket.id}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <PassengerTicketLabel ticket={ticket} />
            {getDownloadTicketComponent(ticket_type, ticket)}
          </Stack>
        ))}
    </Stack>
  );
};
